import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Switch, Select, Form, Input,Upload, InputNumber } from 'antd';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import useFetchOrganizationTypes from '../../hooks/fetchOrganizationTypes';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
// import useFetchRoles from '../../hooks/fetchRoles';
import { LeftCircleOutlined, BorderTopOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import InputMask from 'react-input-mask';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
console.log(app);
const { TextArea } = Input;

const AddOrgType = () => {
  const { t } = useTranslation(['common']);
  const [addUserResp, setAddOrgTypeResp] = useState({});
  const [uploadObj, setUploadObj] = useState({});
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadLogo, setuploadLogo] = useState(true);
  const [imageUrl, setImageUrl] = useState();
  const [uploadedImg, setUploadedImg] = useState('');

  const token=getTokenfromUserObj()
  const headers={auth:token}
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const handleuploadChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      info.file?console.log(info.file.response.data.Location):console.log("Not found"); 
      info.file?setUploadedImg(info.file.response.data.Location):" "
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setuploadLogo(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }t
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(orgs);
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/orgtype/add`, uploadObj,{headers:{auth:token}});
      if (res.data.statusCode === 200) {
        setAddOrgTypeResp(res.data);
        setTimeout(() => {
          navigate('/organizations/types');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      organizationType: values.organizationType ? values.organizationType : null,
      image: uploadedImg ? uploadedImg : null,
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId: user.userId,
    });
    setShow(true);
  };
  console.log(uploadObj);
  const submitData = () => {
    console.log('calling');
    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // uploadData(uploadObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const c = useFetchCauseCategories();
  console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  function goBack() {
    navigate('/organizations/types',{replace:true});
   }
   window.addEventListener('popstate', goBack);
  return (
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                navigate('/organizations/types');
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add Organization Type')} </h2>
          </div>{' '}
        </div>
        <div class='col mb-5 w-50 mt-4'>
          <div class='col-lg-9 align-self-center mt-2 mb-4'>
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['id']: 1,
                ['isActive']: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {/* Select box for Role */}

              {/* <Form.Item
                colon={false}
                label='Organization'
                name='organizationId'
                rules={[
                  {
                    required: true,
                    message: 'Select Organization',
                  },
                ]}
              >
                <Select
                  style={{
                    width: 180,
                  }}
                  placeholder='Select Organization'
                >
                  {orgs
                    ? orgs.map((org) => {
                        return (
                          <Option key={org.organizationId} value={org.organizationId}>
                            {org.organizationName}
                          </Option>
                        );
                      })
                    : ' '}
                </Select>
              </Form.Item> */}
              <Form.Item
                label='Organization Type'
                name='organizationType'
                defaultValue='1'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Enter Organization Type',
                  },
                ]}
              >
                <Input type='text'  placeholder='Enter Organization Type' />
              </Form.Item>
              <Form.Item label='Icon'   colon={false}  name='image'>
            <Upload
              // name="avatar"
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}

              action={`${app.URL}/upload/logo`}

              // action={`${app.URL}/api/upload/logo`}

              headers={headers}
              beforeUpload={beforeUpload}
              onChange={handleuploadChange}
            >
              {/* {imageUrl ? (
                <img
                  src={imageUrl}
                  alt='avatar'
                  style={{
                    width: '100%',
                  }}
                />
              ) : (
                uploadButton
              )} */}
                {uploadLogo ? 
              loading?uploadButton:uploadButton
              : (
                <img
                  src={imageUrl}
                  alt='avatar'
                  style={{
                    width: '100%',
                  }}
                />
              ) }
            </Upload>
          </Form.Item>
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>

              {/* Select box for Organization */}

              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to add Organization Type?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}

                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Save
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrgType;
